import clone from 'lodash/clone';

import workspace from "../workspace";
import {POINT_PROPERTY} from "../../../../constants";
import {
  getCountertopArea,
  //getExportedManualCalculateBacksplashes,
  getExportedManualCalculateCountertops,
  //getExportedManualCalculateEdges,
  getSlabImagesAreaGrouped,
  manualCalculationsCountertopArea
} from "../../../../helpers/sqftCalculations";
import config from "../../store/sqftConfig";
import store from "./../../../../../../store";
import sqftImageManager from "../../store/sqftImageManager";
import slabWorkspace from "../slab/slabWorkspace";
import {loaderDisable, loaderEnable} from "../../../../../ui/loaderView";
import workspaceControllers, {getControllersExportData} from "../../store/workspaceControllers";
import {getQtCatName} from "../../../../helpers/sqftQuotesHelper";
import {
  SHAPE_PART_IDS_FROM_ADDITIONAL_SHAPES_LIST,
} from "../../../../constantsFeature";
import {loadScriptPromise} from "../../../../../../misc/loadScript";
import {ASYNC_SCRIPTS} from "../../../../../../loadingLogic";
import SqftStore from "../../store/sqftStore";
import {enableSlabMode} from "../../store/canvasHelper";
import {showSlabTool} from "../../../../../../actions/sqftSlabFunctions";

/**
 * Get core SQFT data without images (fast snapshot version)
 */
export const prepareSQFTDataCore = () => {
  const state = store.getState();
  const showManualCalculation = state.sqftManualCalculationState.showManualCalculation;
  const measureUnit = state.sqftState.measureUnit;
  const miteredEdges = workspace.miteredController ? workspace.miteredController.getExportedMiteredEdges() : [];

  let shapesList = workspace.getShapes()
    .filter(shp => {
      return shp.export && !SHAPE_PART_IDS_FROM_ADDITIONAL_SHAPES_LIST.includes(shp.partId)
    })
    .map(shp => shp.export())
    .concat(miteredEdges);

  const totalSQFTArea = getCountertopArea();

  return {
    bumpouts: workspace.getBumpouts(),
    measureUnit: measureUnit,
    sinks: workspace.getSink(),
    radii: workspace.getPointProperty(POINT_PROPERTY.arcLength),
    corners: workspace.getPointProperty(POINT_PROPERTY.angle),
    totalInches: totalSQFTArea.totalArea,
    shapeLength: totalSQFTArea.shapeLength,
    objIds: workspace.getObjIds(),
    removedFeatures: workspaceControllers.removedFeatures.getResources(),
    textBoxes: workspace.textBoxManager.getExportedTextBoxes(),
    slabAdditionalShapesList: slabWorkspace.slabAdditionalShapes.exportData(),
    slabImagesTotalArea: getSlabImagesAreaGrouped(),
    squareFeet: showManualCalculation ? manualCalculationsCountertopArea() : totalSQFTArea.totalAreaToMeasureUnit,
    countertops: showManualCalculation ? getExportedManualCalculateCountertops() : shapesList,
    manualCalculate: showManualCalculation,
    controllers: getControllersExportData(),
    underlayment: workspace.underlaymentController ? workspace.underlaymentController.exportData() : []
  };
};

/**
 * Get images for SQFT data (slow part)
 */
const prepareSQFTDataImages = async (showManualCalculation, qtCatName, roomsWithVisitedSlabTool, slabImages) => {
  const isInSlabMode = SqftStore.isSlabMode();
  const sqftApplianceImages = workspace.resultImages.getCanvasApplianceImages();
  const sqFtSlabImage = roomsWithVisitedSlabTool.includes(qtCatName) && slabImages && slabImages.length > 0
    ? workspace.resultImages.getSlabResultImage(config.defaultScaleExport)
    : "";
  const sqFtSlabCalcImage = roomsWithVisitedSlabTool.includes(qtCatName)
    ? workspace.resultImages.getSlabCalcImage(config.defaultScaleExport)
    : "";
  const sqftCanvasImage = await getCanvasImage(showManualCalculation);

  let images3D = [...workspaceControllers.images3d.getResources()];
  const images3DAutoSaved = workspaceControllers.images3dAutoSaved.getResources();
  if (images3DAutoSaved && images3DAutoSaved.length) {
    images3D.push(images3DAutoSaved[images3DAutoSaved.length - 1]);
  }
  //save images local (for dev purposes)

  // const link = document.createElement("a");
  // link.href = sqftCanvasImage.replace("image/png", "image/octet-stream");
  // link.download = 'slabImage' + Date.now() + '.png';
  // document.body.appendChild(link);
  // link.click();
  // document.body.removeChild(link);
  if (isInSlabMode) {
    enableSlabMode();
    store.dispatch(showSlabTool(true));
  }

  return {
    canvasImage: sqftCanvasImage,
    sqFtSlabImage: sqFtSlabImage,
    sqFtSlabCalcImage: sqFtSlabCalcImage,
    sqftApplianceImages: sqftApplianceImages,
    images3D: images3D,
    slabImages: sqftImageManager.getExportedSlabImages(),
  };
};

/**
 * Full SQFT data with images
 */
export const prepareSQFTData = async () => {
  const state = store.getState();
  const roomsWithVisitedSlabTool = state.sqftSlabState.roomsWithVisitedSlabTool;
  const showManualCalculation = state.sqftManualCalculationState.showManualCalculation;
  const slabImages = state.sqftSlabState.croppedSlabImages;
  const qtCatName = getQtCatName();

  let workspaceCenter = clone(workspace.getCenter());

  // Get core data (fast)
  const coreData = prepareSQFTDataCore();

  // Get images (slow)
  const imagesData = await prepareSQFTDataImages(
    showManualCalculation,
    qtCatName,
    roomsWithVisitedSlabTool,
    slabImages
  );

  workspace.setCenter(workspaceCenter.x * 2, workspaceCenter.y * 2);

  return {
    ...coreData,
    ...imagesData
  };
};

const getCanvasImage = async (showManualCalculation) => {
  if (showManualCalculation) {
    const manualDiv = document.querySelector(".manual-window");
    if (manualDiv) {
      loaderEnable("loader.savingQuoteText");
      manualDiv.classList.add("manual-window--screenshot");
      try {
        await loadScriptPromise(ASYNC_SCRIPTS.html2canvas, "html2canvas");
        const canvasElement = await window.html2canvas(manualDiv);
        manualDiv.classList.remove("manual-window--screenshot");
        loaderDisable();
        if (canvasElement && canvasElement.toDataURL) {
          return canvasElement.toDataURL("image/jpeg", 0.7) // we don't need super quality here
        }
      } catch (e) {
        loaderDisable();
      }
    }
  }
  return workspace.resultImages.getCanvasImageScaled(config.defaultScaleExport);
};
